import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FournisseurDTO } from '../../customs/_models/FournisseurDTO';
import { emplacementDTO } from '../../customs/_models/emplacementDto';
import { ProduitStockDTO } from '../../customs/_models/ProduitStockDTO';
import { MouvementStocktDTO } from '../../customs/_models/MouvementStockDTO';

@Injectable({
  providedIn: 'root'
})
export class MouvementStocktService {

  private apiUrl = environment.base_url + '/api/mouvement';

  constructor(private http: HttpClient) {}

  // 🔹 Créer un nouveau fournisseur
  createMouvement(produit: MouvementStocktDTO): Observable<MouvementStocktDTO> {
    return this.http.post<MouvementStocktDTO>(this.apiUrl, produit, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  // 🔹 Modifier un fournisseur existant
  updateMouvement(id: number, produit: MouvementStocktDTO): Observable<MouvementStocktDTO> {
    return this.http.put<MouvementStocktDTO>(`${this.apiUrl}/${id}`, produit, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  // 🔹 Récupérer tous les fournisseurs (avec flag = true côté backend)
  getAllMouvements(): Observable<MouvementStocktDTO[]> {
    return this.http.get<MouvementStocktDTO[]>(this.apiUrl);
  }

  // 🔹 Récupérer un fournisseur par son ID
  getMouvementById(id: number): Observable<MouvementStocktDTO> {
    return this.http.get<MouvementStocktDTO>(`${this.apiUrl}/${id}`);
  }

  // 🔹 Suppression logique (soft delete)
  deleteMouvement(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
